// Birthday Party action types

const birthdayPartyActionTypes = {
  FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA: 'FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA',
  FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_SUCCESS: 'FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_SUCCESS',
  FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR: 'FETCH_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR',
  CLEAR_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR: 'CLEAR_PARTY_BOOKING_WIDGET_SEARCH_DATA_ERROR',
  SET_PARTY_BOOKING_WIDGET_FORM_SEARCH_DATA: 'SET_PARTY_BOOKING_WIDGET_FORM_SEARCH_DATA',
  SET_SELECTED_BIRTHDAY_PARTY: 'SET_SELECTED_BIRTHDAY_PARTY',
  TOGGLE_BIRTHDAY_PARTY_DATE_PICKER: 'TOGGLE_BIRTHDAY_PARTY_DATE_PICKER',
  CLEAR_PARTY_BOOKING_RESERVATION: 'CLEAR_PARTY_BOOKING_RESERVATION',
  SET_GUESTS_OF_HONOR: 'SET_GUESTS_OF_HONOR',
  CLEAR_PARTY_DATE: 'CLEAR_PARTY_DATE',
  CLEAR_GUESTS_OF_HONOR: 'CLEAR_GUESTS_OF_HONOR',
  SET_SELECTED_PARTY_TIME: 'SET_SELECTED_PARTY_TIME'
};

export default birthdayPartyActionTypes;
